export enum MediaCategory {
  Wholesaler = 'wholesaler',
  Theme = 'theme',
  RoadAssistance = 'road-assistance'
}
